/* tslint:disable */
import {
  CompanyAccount
} from '../index';

declare var Object: any;
export interface PropertyDetailsInterface {
  "year_built"?: number;
  "description"?: string;
  "features"?: Array<any>;
  "property_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  companyAccount?: CompanyAccount;
}

export class PropertyDetails implements PropertyDetailsInterface {
  "year_built": number;
  "description": string;
  "features": Array<any>;
  "property_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  companyAccount: CompanyAccount;
  constructor(data?: PropertyDetailsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyDetails`.
   */
  public static getModelName() {
    return "PropertyDetails";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyDetails for dynamic purposes.
  **/
  public static factory(data: PropertyDetailsInterface): PropertyDetails{
    return new PropertyDetails(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyDetails',
      plural: 'PropertyDetails',
      path: 'PropertyDetails',
      idName: 'id',
      properties: {
        "year_built": {
          name: 'year_built',
          type: 'number'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "features": {
          name: 'features',
          type: 'Array&lt;any&gt;'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        companyAccount: {
          name: 'companyAccount',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
      }
    }
  }
}
